import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const edittableColumnDateProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
  // input属性
  maxlength: [String, Number],
  placeholder: String,
  clearable: Boolean,
  format: String,
  sourceFormat: String,
})

export type EdittableColumnDateProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnDateProps>>>

export default defineComponent({
  name: 'OEdittableColumnDate',
  inheritAttrs: false,
  props: edittableColumnDateProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
